import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { decryptValue } from '../data/encryption'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    let modifiedReq = req.clone();

    if (modifiedReq.headers.get('skip')) {
      console.log("Code is here");
      const headers = modifiedReq.headers.delete('skip');
      modifiedReq = modifiedReq.clone({ headers });

      return next.handle(modifiedReq);
    }
    else {
      const authToken = decryptValue(localStorage.getItem('UserToken'));
      if (authToken != null) {
        const authRequest = req.clone({
          setHeaders: { 'access-token': authToken }
        });
        return next.handle(authRequest);
      }
      return next.handle(req);
    }
  }


}